import { FormProvider, useForm } from "react-hook-form";
import { Modal } from "@shared/ui/modal/modal";
import { Input } from "@shared/ui/input/input";
import {
  IconCalendar,
  IconClockHour8,
  IconSearch,
  IconSquareRoundedX,
} from "@tabler/icons-react";
import s from "./add-appointment-by-teacher.module.scss";
import classNames from "classnames";
import { useState } from "react";
import { format } from "date-fns";
import { useAddAppointmentByTeacher } from "../../api/useAddAppointmentByTeacher";
import { useMyStudents } from "../../api/useMyStudents";
import { useAddAppointmentByTeacherModal } from '../../model/use-add-appointment-by-teacher-modal';
import { getFullName } from '@utils/lib/getFullname';
import { useProfile } from "@shared/api/useProfile";
import { TZDate } from "@date-fns/tz";
import { TextWithEmoji } from "@shared/ui/text-with-emoji/text-with-emoji";

const months = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

export const AddAppointmentByTeacherModal = () => {
	const { close, isOpen, modalParams } = useAddAppointmentByTeacherModal();

  const [searchValue, setSearchValue] = useState("");
	
  const { data: students } = useMyStudents(undefined, isOpen);
  const { data: profile } = useProfile();
	const { mutate: createAppointment } = useAddAppointmentByTeacher(modalParams?.params)
  
	const [selectedInstrument, setSelectedInstrument] = useState(profile?.instruments[0]?.id);

  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = handleSubmit((data) => {
    setSearchValue(data?.q);
  });

  const filterStudents = (students, searchQuery) => {
    return students?.filter((student) => {
      const fullName = student?.student_id
        ? getFullName(student?.student)
        : null;

      return (
        fullName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        student?.student?.email
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        student?.student_email
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    });
  };

  const filteredStudents = filterStudents(students, searchValue);

	const onClick = (student_id) => {		
		const date = modalParams?.date

		createAppointment([student_id, modalParams?.time, format(date, 'dd-MM-yyyy'), selectedInstrument])
		close()
	}

	if(!isOpen){
		return null
	}

  return (
    <Modal {...{ isOpen, close }}>
      <div className={s.card}>
        <div className={s.header}>
          <div className={s.title}>Добавить занятие <p className={s.subtitle}>{'Занятие ' + format(new Date(modalParams?.date), 'dd.MM.yyyy') + " " + modalParams?.time}</p></div>
          <p className={s.instrumentsTitle}>Инструмент</p>
          <div className={s.instruments}>
            {profile?.instruments?.map(el => (
              <button className={classNames(s.instrumentButton, selectedInstrument === el.id && s.active)} onClick={() => setSelectedInstrument(el.id)}>
								<TextWithEmoji text={el.name}/>
							</button>
            ))}
          </div>
					<p className={s.instrumentsTitle}>Мои ученики</p>
					<FormProvider {...methods}>
            <Input
              placeholder="Поиск"
              leftIcon={<IconSearch size={18} className={s.searchBtn} />}
              name="q"
              className={s.input}
              onBlur={onSubmit}
							// onChange={() => console.log('log')}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  onSubmit();
                }else{
                  onSubmit();
								}
              }}
            />
          </FormProvider>
        </div>
        {students?.length > 0 ? (
          filteredStudents.length > 0 ? (
            <div className={s.scroller}>
              <div className={s.list}>
                {filteredStudents?.map(
                  ({ student, student_id, student_email, id }) => {
                    const isRegistered = !!student_id;
                    const date = new TZDate(
                      student?.upcoming_appointment?.starts_at, profile?.timezone
                    );

                    return (
                      <div
                        onClick={() => {
                          onClick(student_id)
                        }}
                        className={s.studentCard}
                        key={"student_" + id}
                      >
                        <div className={s.avatar}>
                          <img
                            src={
                              student?.avatar
                                ? process.env.REACT_APP_STORAGE_URL +
                                  student?.avatar?.image
                                : process.env.REACT_APP_STORAGE_URL +
                                  "images/default_avatar.png"
                            }
                            alt=""
                          />
                        </div>
                        <div className={s.content}>
                          <div className={s.name}>
                            {isRegistered
                              ? getFullName(student)
                              : student_email}
                          </div>
                          <div
                            className={classNames(
                              s.badge,
                              student?.upcoming_appointment ? s.active : ""
                            )}
                          >
                            {isRegistered ? (
                              student?.upcoming_appointment ? (
                                <>
                                  <IconCalendar size={12} /> Занятие{" "}
                                  {date.getDate() +
                                    " " +
                                    months[date.getMonth()]}
                                </>
                              ) : (
                                <>
                                  <IconSquareRoundedX size={12} /> Нет занятий
                                </>
                              )
                            ) : (
                              <>
                                <IconClockHour8 size={12} /> В ожидании
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          ) : (
            <div className={s.notFound}>У вас нет такого ученика</div>
          )
        ) : (
          <div className={s.notFound}>
            У вас пока нет учеников, но это легко исправить...
          </div>
        )}
      </div>
    </Modal>
  );
};
